import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  loading: false,
  error: null,
  message: "",
};

export const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {
    // Saga triggers
    getJobs: () => {},
    getOneJob: () => {},
    addJob: () => {},
    updateJob: () => {},
    removeJob: () => {},

    // Local reducer
    searchJobByTitle: (state, action) => {
      const searchText = action.payload.toLowerCase();
      state.data = state.data.filter((job) =>
        job.jobTitle.toLowerCase().includes(searchText)
      );
    },

    // Saga will dispatch this on success
    successJob: (state, action) => {
      state.data = Array.isArray(action.payload)
        ? action.payload
        : [action.payload];
      state.loading = false;
      state.error = null;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    setLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
  },
});

// ✅ Export actions for saga
export const {
  getJobs,
  getOneJob,
  addJob,
  updateJob,
  removeJob,
  searchJobByTitle,
  successJob,
  setError,
  setLoading,
} = jobSlice.actions;

export default jobSlice.reducer;
